import React from 'react';
import './Tooltip.css';

/**
 * Field-level help tooltip.
 *
 * Usage:
 *   <label>Titel <Tooltip text="De naam die studenten te zien krijgen." /></label>
 *
 * The tooltip bubble appears above the ? icon on hover / keyboard focus.
 * `position` can be 'top' (default) or 'bottom'.
 */
const Tooltip = ({ text, position = 'top', children }) => {
  if (!text) return children || null;
  return (
    <span className={`field-tooltip field-tooltip-${position}`} tabIndex={0} role="note" aria-label={text}>
      {children || <span className="tooltip-icon" aria-hidden="true">?</span>}
      <span className="tooltip-bubble" role="tooltip">{text}</span>
    </span>
  );
};

export default Tooltip;
